import * as React from 'react';
import { useCallback } from 'react';
import { FormState } from 'final-form';

import { Form, Props } from '../Form/Form';
import PassengersConsents from '../PassengersConsents/PassengersConsents';
import PassengersToolbar from '../Form/PassengersToolbar/PassengersToolbar';

const FormBlockSlot: React.FC<Props> = props => {
	const renderToolbar = useCallback(
		({ values }: FormState<Record<string, any>>, formRef: React.RefObject<HTMLFormElement>) => (
			<>
				<PassengersConsents
					customer={props.customer}
					login={values.customer?.email}
					isAuthorized={!!props.userInfo?.userProfile}
				/>

				<PassengersToolbar
					formRef={formRef}
					disableBooking={props.orderSubsidyState?.isSubsidiesRejected}
					loading={props.orderSubsidyState?.isLoading}
					currentStep={props.currentStep}
					setNextStep={props.setNextStep}
					showConsents={false}
					hasForm
				/>
			</>
		),
		[props.userInfo, props.customer, props.orderSubsidyState, props.currentStep, props.setNextStep]
	);

	return <Form {...props} renderToolbar={renderToolbar} />;
};

export default FormBlockSlot;
